import alloy from "@alloyidentity/web-sdk";
import type { EvaluationData } from "@alloyidentity/web-sdk/dist/types";
import { getConfig } from "./getConfig";
import { isProductionMode } from "./importMeta";
import { getItem, setItem } from "./sessionStorage";

export const alloyIovationBlackboxStorageKey = "bread-member-portal-iovation-blackbox";

type AlloyIovationData = {
	iovationBlackboxId?: string;
	neuroIdSiteId?: string;
	neuroUserId?: string;
};

export const getAlloyIovationData = async (
	evaluationData?: EvaluationData,
): Promise<AlloyIovationData | null> => {
	const cachedData = getItem<AlloyIovationData>(alloyIovationBlackboxStorageKey);

	if (cachedData && !evaluationData) {
		return cachedData;
	}

	const key = getConfig("alloysdkkey");
	const journeyToken = getConfig("alloyjourneytoken");

	if (!key) {
		return null;
	}

	const { neuroIdSiteId, neuroUserId, iovationBlackboxId } = await alloy.init({
		key,
		production: isProductionMode(),
		...(evaluationData ? { evaluationData } : {}),
		...(journeyToken ? { journeyToken } : {}),
	});

	const alloyIovationData = {
		iovationBlackboxId,
		neuroIdSiteId,
		neuroUserId,
	};

	if (alloyIovationData.iovationBlackboxId) {
		setItem(alloyIovationBlackboxStorageKey, alloyIovationData);
	}
	return alloyIovationData;
};
